import styled from 'styled-components'

const ShippingItemName = styled.div`
  display: inline-flex;
  gap: 3px;
`

export default ShippingItemName
